module.exports = __webpack_public_path__ + "media/images/flags/US-CA-46fb5a1c016982c65635e84171779ace.svg";